var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      this.error
        ? _c("MMP_DRT_AddError", {
            attrs: {
              customerProjectId: _vm.customerProjectId,
              drt_releaseId: _vm.drt_releaseId,
              errLat: this.errLat,
              errLayer: this.errLayer,
              errLong: this.errLong,
              map: _vm.map,
              releases: this.releases,
              selectedDataset: this.selectedDataset,
              severityOptions: this.severityOptions,
              statusOptions: this.statusOptions,
              user: this.user,
            },
            on: {
              refresh: function ($event) {
                return _vm.$emit("refresh", $event)
              },
              notification: function ($event) {
                return _vm.$emit("notification", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("MMP_DRT_UpdateError", {
        attrs: {
          severityOptions: this.severityOptions,
          statusOptions: this.statusOptions,
          updateErrorDataSource: _vm.updateErrorDataSource,
          userEmail: this.user.email,
          user: this.user,
        },
        on: {
          refresh: function ($event) {
            return _vm.$emit("refresh", $event)
          },
          notification: function ($event) {
            return _vm.$emit("notification", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("MMP_DRT_ErrorManager", {
        attrs: { customerProjectId: _vm.customerProjectId, map: _vm.map },
      }),
      _vm._v(" "),
      this.errorsLayerVisibility && !_vm.panelClosed
        ? _c(
            "div",
            { staticClass: "error-control-toolbar" },
            [
              _c("div", { staticClass: "ec-title" }, [
                _c(
                  "span",
                  { staticClass: "ec-title-badge" },
                  [
                    _c("fa", {
                      staticClass: "ec-title-icon",
                      attrs: { icon: ["fas", "exclamation-triangle"] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "ec-title-text" }, [
                  _vm._v("Error Controls"),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ec-separator" }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "ec-segment",
                  attrs: { role: "group", "aria-label": "Error edit mode" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "ec-seg-btn",
                      class: { "ec-seg-btn--active": this.error },
                      attrs: { type: "button", disabled: this.updateError },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggleError")
                        },
                      },
                    },
                    [
                      _c("fa", {
                        staticClass: "ec-seg-icon",
                        attrs: { icon: ["fas", "plus"] },
                      }),
                      _vm._v(" Add\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "ec-seg-btn",
                      class: { "ec-seg-btn--active": this.updateError },
                      attrs: { type: "button", disabled: this.error },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggleUpdateError")
                        },
                      },
                    },
                    [
                      _c("fa", {
                        staticClass: "ec-seg-icon",
                        attrs: { icon: ["fas", "pencil-alt"] },
                      }),
                      _vm._v(" Update\n        "),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "ec-status" } }, [
                _vm.error || _vm.updateError
                  ? _c("div", { staticClass: "ec-status" }, [
                      _c("span", { staticClass: "ec-status-dot" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ec-status-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.error
                              ? "Click the map to place an error"
                              : "Select an error to update"
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ec-separator" }),
              _vm._v(" "),
              _c(
                "b-dropdown",
                {
                  attrs: {
                    dropup: "",
                    right: "",
                    boundary: "window",
                    size: "sm",
                    variant: "link",
                    "toggle-class": "ec-export-toggle",
                    "menu-class": "ec-export-menu",
                    "no-caret": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "button-content",
                        fn: function () {
                          return [
                            _c("fa", {
                              staticClass: "ec-seg-icon",
                              attrs: { icon: ["fas", "download"] },
                            }),
                            _vm._v(" Export\n          "),
                            _c("fa", {
                              staticClass: "ec-caret",
                              attrs: { icon: ["fas", "chevron-up"] },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2258011032
                  ),
                },
                [
                  _vm._v(" "),
                  _c("h6", { staticClass: "ec-menu-caption" }, [
                    _vm._v("Download as"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("exportFile", "shape")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "ec-menu-chip ec-menu-chip--shape" },
                        [_c("fa", { attrs: { icon: ["fas", "layer-group"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "ec-menu-item-text" }, [
                        _c("span", { staticClass: "ec-menu-item-title" }, [
                          _vm._v("Shapefile"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ec-menu-item-sub" }, [
                          _vm._v(".shp geometry bundle"),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$emit("exportFile", "csv")
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        { staticClass: "ec-menu-chip ec-menu-chip--csv" },
                        [_c("fa", { attrs: { icon: ["fas", "table"] } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "ec-menu-item-text" }, [
                        _c("span", { staticClass: "ec-menu-item-title" }, [
                          _vm._v("CSV"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "ec-menu-item-sub" }, [
                          _vm._v("Spreadsheet table"),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }